import * as tslib_1 from "tslib";
import { removeAttachmentPreviewsForRow } from 'owa-mail-attachment-previews';
import { lazyRemoveCouponFromStore } from 'owa-mail-coupon-peek';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import getTableToRowRelationKey from 'owa-mail-list-store/lib/utils/getTableToRowRelationKey';
import conversationCache from 'owa-mail-store/lib/store/conversationCache';
import { action, select } from 'satcheljs/lib/legacy';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
export default select({
    tableViewConversationRelations: function () { return listViewStore.tableViewConversationRelations; },
    tableViews: function () { return listViewStore.tableViews; },
    conversationItems: function () { return listViewStore.conversationItems; },
    conversationCache: function () { return conversationCache; },
})(action('removeConversationData')(function removeConversationData(rowKey, tableView, state) {
    var e_1, _a;
    var tableConversationRelationKey = getTableToRowRelationKey(rowKey, tableView.id);
    var tableConversationRelations = state.tableViewConversationRelations;
    var conversationId = tableConversationRelations.get(tableConversationRelationKey).id;
    if (!tableConversationRelations.has(tableConversationRelationKey)) {
        throw new Error('Conversation not found in store');
    }
    // 1. Remove table Conversation relation
    tableConversationRelations.delete(tableConversationRelationKey);
    // 2. Check to see if there are any other table relations for this converation
    var converationFoundInOtherTables = false;
    try {
        for (var _b = tslib_1.__values(state.tableViews.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var table = _c.value;
            // We should not refer to the current table
            if (table.id != tableView.id && table.rowIdToRowKeyMap.get(conversationId)) {
                converationFoundInOtherTables = true;
                break;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // 3. Only remove conversation from listview store when it is not referenced anymore from any table
    if (!converationFoundInOtherTables) {
        state.conversationItems.delete(conversationId);
        // Remove attachment preview well and atttachment view states for this conversation
        removeAttachmentPreviewsForRow(conversationId);
        // Remove coupon data
        if (isControlFeatureEnabled('tri-coupon-peek')) {
            lazyRemoveCouponFromStore.import().then(function (removeCouponFromStore) {
                removeCouponFromStore(conversationId);
            });
        }
        // Remove cached ConversationItemParts from conversationCache if exists
        state.conversationCache.remove(conversationId);
    }
}));
//# sourceMappingURL=removeConversationData.js.map